import { BasePalette, Palette } from '../general/color-palette';
import { Theme } from '../general/theme';
import { TextDirection } from '../general/text-direction';

const grey: BasePalette = {
  50: '#000000', // Black
  100: '#131313', // Licorice
  120: '#333333', // Opel grey
  150: '#4d4d4d', // Very dark gray
  200: '#767676', // Dark grey
  240: '#888888', // Darker grey
  250: '#777777', // Sonic silver
  280: '#797979', // Sonic silver
  300: '#7f7f7f', // Trolley grey
  450: '#bcbcbc', // Can it be a bit lighter grey?
  500: '#cccccc', // Pastel gray
  700: '#f3f3f3', // Anti-flash white
  800: '#f9f9f9', // Ghost White
  900: '#ffffff', // White
};

const yellow: Palette = {
  50: '#000000', // Black
  100: '#CCCCCC', // Dark grey
  500: '#f7ff14', // School bus yellow
  900: '#ffffff', // White
};

const red: Palette = {
  800: '#CB1A2A',
  900: '#ff0000',
};

export const opelNewTheme: Theme = {
  currentDirection: 'ltr',
  color: {
    base: grey,
    primary: yellow,
    secondary: red,
    accent: {},
  },
  font: {
    normal: 'OpelNextLight, Arial',
    primary: 'OpelNext, Arial',
    secondary: 'OpelNextLight, Arial',
    tertiary: 'Verdana, sans-serif',
    accent: 'OpelNextBold, Arial',
    accentBody: 'OpelNextLight, Arial',
    commonIcons: 'Icons-Common',
  },
  fontSize: {
    small: 12,
    normal: 14,
    big: 18,
    large: 24,
    extraLarge: 40,
    huge: 60,
  },
  breakPoint: {
    mobile: 450,
    tablet: 960,
    phablet: 768,
    smallDesktop: 1280,
  },
  get direction() {
    return this.currentDirection;
  },
  set direction(direction: TextDirection) {
    this.currentDirection = direction;
  },
};
